/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-20[_ngcontent-%COMP%]{padding:1.25rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin-settings/components/email-test/email-test.component.scss.shim.ngstyle.js.pre-build-optimizer.js